/* */ 
(function(process) {
  'use strict';
  var $Ref = require('./ref'),
      Pointer = require('./pointer'),
      debug = require('./util/debug'),
      url = require('./util/url');
  module.exports = bundle;
  function bundle(parser, options) {
    debug('Bundling $ref pointers in %s', parser.$refs._root$Ref.path);
    var inventory = [];
    crawl(parser, 'schema', parser.$refs._root$Ref.path + '#', '#', inventory, parser.$refs, options);
    remap(inventory);
  }
  function crawl(parent, key, path, pathFromRoot, inventory, $refs, options) {
    var obj = key === null ? parent : parent[key];
    if (obj && typeof obj === 'object') {
      if ($Ref.is$Ref(obj)) {
        inventory$Ref(parent, key, path, pathFromRoot, inventory, $refs, options);
      } else {
        var keys = Object.keys(obj);
        var defs = keys.indexOf('definitions');
        if (defs > 0) {
          keys.splice(0, 0, keys.splice(defs, 1)[0]);
        }
        keys.forEach(function(key) {
          var keyPath = Pointer.join(path, key);
          var keyPathFromRoot = Pointer.join(pathFromRoot, key);
          var value = obj[key];
          if ($Ref.is$Ref(value)) {
            inventory$Ref(obj, key, path, keyPathFromRoot, inventory, $refs, options);
          } else {
            crawl(obj, key, keyPath, keyPathFromRoot, inventory, $refs, options);
          }
        });
      }
    }
  }
  function inventory$Ref($refParent, $refKey, path, pathFromRoot, inventory, $refs, options) {
    if (inventory.some(function(i) {
      return i.parent === $refParent && i.key === $refKey;
    })) {
      return;
    }
    var $ref = $refKey === null ? $refParent : $refParent[$refKey];
    var $refPath = url.resolve(path, $ref.$ref);
    var pointer = $refs._resolve($refPath, options);
    var depth = Pointer.parse(pathFromRoot).length;
    var file = url.stripHash(pointer.path);
    var hash = url.getHash(pointer.path);
    var external = file !== $refs._root$Ref.path;
    var extended = $Ref.isExtended$Ref($ref);
    inventory.push({
      $ref: $ref,
      parent: $refParent,
      key: $refKey,
      pathFromRoot: pathFromRoot,
      depth: depth,
      file: file,
      hash: hash,
      value: pointer.value,
      circular: pointer.circular,
      extended: extended,
      external: external
    });
    crawl(pointer.value, null, pointer.path, pathFromRoot, inventory, $refs, options);
  }
  function remap(inventory) {
    inventory.sort(function(a, b) {
      if (a.file !== b.file) {
        return a.file < b.file ? -1 : +1;
      } else if (a.hash !== b.hash) {
        return a.hash < b.hash ? -1 : +1;
      } else if (a.circular !== b.circular) {
        return a.circular ? -1 : +1;
      } else if (a.extended !== b.extended) {
        return a.extended ? +1 : -1;
      } else if (a.depth !== b.depth) {
        return a.depth - b.depth;
      } else {
        return b.pathFromRoot.lastIndexOf('/definitions') - a.pathFromRoot.lastIndexOf('/definitions');
      }
    });
    var file,
        hash,
        pathFromRoot;
    inventory.forEach(function(i) {
      debug('Re-mapping $ref pointer "%s" at %s', i.$ref.$ref, i.pathFromRoot);
      if (!i.external) {
        i.$ref.$ref = i.hash;
      } else if (i.file === file && i.hash === hash) {
        i.$ref.$ref = pathFromRoot;
      } else if (i.file === file && i.hash.indexOf(hash + '/') === 0) {
        i.$ref.$ref = Pointer.join(pathFromRoot, Pointer.parse(i.hash));
      } else {
        file = i.file;
        hash = i.hash;
        pathFromRoot = i.pathFromRoot;
        i.$ref = i.parent[i.key] = $Ref.dereference(i.$ref, i.value);
        if (i.circular) {
          i.$ref.$ref = i.pathFromRoot;
        }
      }
      debug('    new value: %s', (i.$ref && i.$ref.$ref) ? i.$ref.$ref : '[object Object]');
    });
  }
})(require('process'));
